export const Basketball = ({ size = 24, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7366 20.1924C22.2607 17.0246 23.3602 10.7891 20.1924 6.26509C17.0246 1.74104 10.7891 0.641562 6.26509 3.80934M17.7366 20.1924C13.2126 23.3602 6.97711 22.2607 3.80934 17.7366C0.641562 13.2126 1.74104 6.97711 6.26509 3.80934M17.7366 20.1924L6.26509 3.80934M19.5784 5.47426C15.8075 11.37 11.0699 14.6875 3.27621 16.8891M13.0606 2.05703C13.4742 7.29685 16.4526 11.5508 21.7075 14.406M2.29427 9.5957C7.07664 11.7764 10.0553 16.0302 10.9411 21.9447"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
